/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import MotiliButton from 'common/components-v2/buttons/MotiliButton';
import { useEffect } from 'react';

const DropzoneRoot = styled.div`
    border: none;
    width: 100%;
    height: auto;
    input[type='file'] {
        display: none;
    }
`;

export default function UploadPhotoRequireButton({
    dataTestId,
    text,
    disabled,
    handleOnDrop,
    size,
    allowFiles,
    buttonStyle,
}) {
    const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
        accept: allowFiles,
        multiple: false,
        noClick: true,
        disabled,
        onDrop: (acceptedFiles, rejectedFiles) => {
            acceptedFiles.forEach(file => {
                file.preview = URL.createObjectURL(file);
            });

            handleOnDrop(acceptedFiles, rejectedFiles);
        },
    });

    useEffect(() => {
        return () => {
            acceptedFiles.forEach(file => {
                if (file.preview) {
                    URL.revokeObjectURL(file.preview);
                }
            });
        };
    }, [acceptedFiles]);

    return (
        <DropzoneRoot
            {...getRootProps()}
            style={{ width: buttonStyle?.width ?? 'auto' }}
        >
            <input {...getInputProps()} />
            <MotiliButton
                dataTestId={dataTestId}
                disabled={disabled}
                moStyle='primary'
                text={text}
                size={size}
                onClick={open}
                style={buttonStyle}
            />
        </DropzoneRoot>
    );
}

UploadPhotoRequireButton.propTypes = {
    dataTestId: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    handleOnDrop: PropTypes.func.isRequired,
    size: PropTypes.string,
    allowFiles: PropTypes.object,
    buttonStyle: PropTypes.object,
};
